import { Spinner } from '@weareopenr/component-library';

// Dropdown options take an icon component rendered as <Icon size="small" />, and Spinner doesn't fit that
// shape. Always greyed out because it's only shown on disabled options while they load.
export const SpinnerIcon = () => <Spinner size="small" disabled />;
